import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VotePageComponent} from "./vote-page.component";
import {RouterModule, Routes} from "@angular/router";
import { VoteCardComponent } from './components/vote-card/vote-card.component';
import {SharedModule} from "../../shared/shared.module";
import { VoteSectionComponent } from './components/vote-section/vote-section.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

const routes: Routes = [{path: '', component: VotePageComponent}]

@NgModule({
  declarations: [
    VotePageComponent,
    VoteCardComponent,
    VoteSectionComponent
  ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        SharedModule,
        MatSnackBarModule,
        MatProgressSpinnerModule
    ]
})
export class VotePageModule {
}
